<template>
    <div class="container fluid">
        <div class="row justify-content-center">
            <div class="how-to-earn-points-container col-8 col-md-6" v-on:click="toggleShowHowToEarnPointsModal()">
        <span class="how-to-earn-points-text">HOW DO I EARN POINTS?
          <BIconChevronDown class="chev-down-white"/>
        </span>
            </div>
        </div>
        <HowToEarnPointsModal v-if="showHowToEarnPointsModal"></HowToEarnPointsModal>
        <div v-if="isHistoricalPredictionsPage" class="text-box">
            <p class="row justify-content-center description-text">Below are the predictions made and points earned by
                {{selectedPlayerUsername}}
            </p>
        </div>
        <hr class="line-break">
        <p class="round-name-text"><b>{{selectedRound.RoundName}}</b></p>
        <div class="olympics-round-text-box">
            <p class="mb-0 olympics-round-text">{{getDayOfWeek(selectedRound.RoundStartDate)}}
                {{getDay(selectedRound.RoundEndDate)}} {{ getMonth(selectedRound.RoundStartDate) }} {{
                getYear(selectedRound.RoundStartDate)
                }}</p>
        </div>
        <div v-for="(discipline, index) in currentPredictions" :key="index">
            <div class="olympics-round-text-box">
                <p class="olympics-round-text">{{discipline.EventName}} | STARTS: {{ getTime(discipline.startsAt) }} |
                    CLOSES: {{
                    getTime(discipline.endsAt) }}</p>
            </div>
            <div class="container discipline-box">
                <div style="position: relative">
                    <img class="discipline-icon" :src="getdisciplineIcon(discipline.DisciplineName)" alt="">
                </div>
                <div class="countries-main-box">
                    <div v-if="discipline.Gold" class="countries-box">
                        <div style="position: relative">
                            <img class="madal-img" :src="getMedalIcon(0)" alt="">
                            <img v-bind:class="!discipline.Bronze ? 'two-medal-country-flags' : 'country-flags'"
                                 :src="getCountryFlag(0, discipline.Gold)" alt="">
                        </div>
                    </div>
                    <div v-if="discipline.Silver" class="countries-box">
                        <div style="position: relative">
                            <img class="madal-img" :src="getMedalIcon(1)" alt="">
                            <img v-bind:class="!discipline.Bronze ? 'two-medal-country-flags' : 'country-flags'"
                                 :src="getCountryFlag(1, discipline.Silver)" alt="">
                        </div>
                    </div>
                    <div v-if="discipline.Bronze" class="countries-box">
                        <div style="position: relative">
                            <img class="madal-img" :src="getMedalIcon(2)" alt="">
                            <img v-bind:class="!discipline.Gold ? 'one-medal-country-flags' : 'country-flags'"
                                 :src="getCountryFlag(2, discipline.Bronze)" alt="">
                        </div>
                    </div>
                    <div v-if="discipline.hasNoTeams" class="countries-box">
                        <h5>This event has no countries as the qualifying rounds are incomplete.</h5>
                    </div>
                </div>
            </div>
            <div v-if="isHistoricalPredictionsPage" class="points-container">
        <span class="how-to-earn-points-text">Points Earned: {{discipline.Points}}
        </span>
            </div>
        </div>
        <div v-if="isHistoricalPredictionsPage" class="edit-predictions-button-box col-12">
            <button class="edit-button"><p class="button-text">Total points Earned: {{getTotalPoints()}}</p></button>
        </div>
        <div v-if="isHistoricalPredictionsPage" class="home-button-box col-12">
            <button v-on:click="onBackClicked()" class="back-button"><p class="button-text">Back</p></button>
        </div>
        <div class="home-button-box col-12">
            <button v-on:click="onHomeClicked()" class="home-button"><p class="button-text">Home</p></button>
        </div>
        <div v-if="!isHistoricalPredictionsPage" class="edit-predictions-button-box col-12 mt-2">
            <button v-on:click="onEditPredictionsClicked()" class="edit-button"><p class="button-text">Edit
                Predictions</p></button>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import ScorePredictorService from "../../services/scorePredictorService";
    import {sports} from "../../config/sports";
    import {mapMutations, mapState} from "vuex";
    import {BIconChevronDown} from 'bootstrap-vue';
    import HowToEarnPointsModal from "@/components/HowToEarnPointsModal";

    export default {
        name: "ViewOlympicsPredictions",
        components: {BIconChevronDown, HowToEarnPointsModal},
        data() {
            return {
                currentPredictions: [],
                isHistoricalPredictionsPage: false,
            }
        },
        computed: mapState(['userData', 'selectedSport', 'selectedLeague', 'selectedRound', 'showHowToEarnPointsModal', 'roundPredictions', 'leaderboardSelectedUser']),
        methods: {
            ...mapMutations(['setRoundPredictions', 'clearRoundPredictions', 'setPointsScoringBreakdown', 'toggleShowHowToEarnPointsModal', 'setLeaderBoardSportSelected', 'setLeaderboardSelectedUser']),

            getTotalPoints() {
                let totalPonts = 0;

                this.currentPredictions.forEach((fixture) => {
                    totalPonts = totalPonts + fixture.Points;
                });
                return totalPonts
            },

            onBackClicked() {
                this.$router.push({path: '/leaderboard'})
            },

            getMedalIcon(medalIndex) {
                if (medalIndex === 0) return require('../../assets/olympics/icons/Gold.png');
                if (medalIndex === 1) return require('../../assets/olympics/icons/Silver.png');
                if (medalIndex === 2) return require('../../assets/olympics/icons/Bronze.png');

            },
            getCountryFlag(medalIndex, countryName) {
                const teamConfig = sports.get(this.selectedSport).get(this.selectedLeague).get(countryName);
                return require(`../../assets/${teamConfig.logo}`)
            },
            getdisciplineIcon(name) {
                const assetName = name.replace(' ', '-');
                const removedSecondSpaces = assetName.replace(' ', '-');
                if (removedSecondSpaces === 'Baseball/Softball') return require(`../../assets/olympics/disciplines/Baseball.png`);
                return require(`../../assets/olympics/disciplines/${removedSecondSpaces}.png`)
            },
            getDayOfWeek(date) {
                return moment(date).format('dddd')
            },
            getDay(date) {
                return moment(date).format('Do')
            },
            getMonth(date) {
                return moment(date).format('MMMM')
            },
            getYear(date) {
                return moment(date).format('YYYY')
            },
            getTime(date) {
                return moment(date).format('hh:mm a')
            },
            formatDate(date) {
                return moment(date).format('LLLL');
            },
            hasGameStarted(startDate) {
                if (startDate > Date.now()) return;
                return;
            },
            onHomeClicked() {
                this.$router.push('/sports');
            },
            onEditPredictionsClicked() {
                this.$router.push('make-predictions');
            },
            addRoundPredictions(fixtures) {
                fixtures.forEach((fixture) => {
                    if (!fixture.Gold && !fixture.Bronze) fixture.hasNoTeams = true;
                    fixture.selectedMedalWinners = [];
                    fixture.selectedMedalWinners.push({gold: fixture.Gold});
                    fixture.selectedMedalWinners.push({silver: fixture.Silver});
                    fixture.selectedMedalWinners.push({bronze: fixture.Bronze});
                    this.currentPredictions.push(fixture);
                    this.setRoundPredictions(fixture);
                });
            },
            async getRoundPredictions() {
                if (this.leaderboardSelectedUser) {
                    const response = await ScorePredictorService.getPlayerRoundPredictions(this.leaderboardSelectedUser.MSISDN, this.selectedRound);
                    this.addRoundPredictions(response.roundPredictions);
                    this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
                    this.isHistoricalPredictionsPage = true;
                    this.setLeaderBoardSportSelected(undefined);
                    this.setLeaderboardSelectedUser(undefined);
                } else {
                    const response = await ScorePredictorService.getRoundPredictions(this.userData.msisdn, this.selectedRound.RoundID);
                    this.addRoundPredictions(response.roundPredictions);
                    this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
                }
            },
            clearState() {
                // this.currentPredictions = [];
                // this.clearRoundPredictions();
            },
        },
        mounted() {
            this.clearState();
            this.getRoundPredictions(this.selectedLeague);
        },
    }
</script>

<style scoped lang="scss">
    .back-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 100%;
        background-color: $current-predictions-home-button;
        border-radius: 5px;
        border: none !important;
        z-index: 0;
        margin-bottom: 1vh;
    }

    .how-to-earn-points-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $icon-container-background-color;
        padding: 0.5rem 0;
        border-radius: 0 0 3px 3px;
        box-shadow: 4px 4px 4px black;
        margin-bottom: 0.5rem;
    }

    .points-container {
        position: relative;
        left: 10%;
        width: 80%;
        background-color: $icon-container-background-color;
        padding: 0.5rem 0;
        border-radius: 0 0 3px 3px;
        box-shadow: 4px 4px 4px black;
        margin-bottom: 0.5rem;
    }


    .how-to-earn-points-text {
        color: $heading-text-color;
    }

    .madal-img {
        position: absolute;
        top: -30px;
        left: -30px;
        height: 40px;
        width: 40px;
    }

    .countries-main-box {
        display: flex;
        justify-content: center;
        margin: 10px;
    }

    .countries-box {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        padding: 15px;
        border-radius: 5px;
        box-shadow: 5px 2px #817c7c;
        border: outset #817c7c 1px;
    }

    .round-name-text {
        color: $round-details-text-color;
        font-size: x-large;
        font-weight: 500;
        margin-bottom: 0;
    }

    .olympics-round-text {
        font-size: large;
        width: 70vw;
    }

    .olympics-round-text-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media screen and (max-width: 900px) {
        .olympics-round-text {
            font-size: medium;
        }
    }

    .country-flags {
        height: 100%;
        width: 100%;
    }

    .two-medal-country-flags {
        height: 60%;
        width: 60%;
    }

    .one-medal-country-flags {
        height: 30%;
        width: 30%;
    }

    .discipline-box {
        display: flex;
        justify-content: center;
        height: auto;
        padding: 20px;
        width: 80vw;
        background: #B1AEAC;
        flex-direction: column;
        border-radius: 5px;
    }

    .discipline-icon {
        position: absolute;
        left: -50px;
        top: -60px;
        width: 60px;
        height: 60px
    }

    @media screen and (min-width: 700px) {
        .discipline-box {
            width: 50vw
        }
    }


    .home-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 100%;
        background-color: $current-predictions-home-button;
        border-radius: 5px;
        border: none !important;
        z-index: 0;
    }

    .edit-button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 8vh;
        width: 100%;
        border: solid $transperent-button-border-color 3px;
        border-radius: 5px;
        background-color: Transparent;
        z-index: 0;
        margin-bottom: 2vh;
    }

    .description-text {
        z-index: 0;
        font-size: large;
        margin: 0;
    }

    .date-text {
        font-size: large;
        margin: 0;
    }

    .button-text {
        color: $button-text-color;
        font-size: large;
        padding: 0;
        margin: 0;
    }

    .line-break {
        color: $line-break-color;
        width: 100%;
    }
</style>
